<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="titlepage" id="bk">
<h1 class="bk"><a class="page" id="pii"></a>Ground Truth</h1>
<h1 class="bk1">A Guide to Tracking Climate Change at Home</h1>
<p class="bkau">Mark L. Hineline</p>
<p class="bkau1">With Illustrations by the Author</p>
<p class="bkpub">The University of Chicago Press</p>
<p class="bkpub1">Chicago and London</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-hineline-0003.vue?22131453